export default (state, action) => {
  switch (action.type) {
    case 'LOAD':
      return {
        ...state,
        invoices: action.invoices,
      };
    case 'UPDATE':
      return {
        ...state,
        invoices: state.invoices.map((item) => (item.id === action.invoice.id ? action.invoice : item)),
      };
    default:
      throw new Error();
  }
};
